"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = function _default(basePath, path) {
  if (basePath) {
    path = path.replace(basePath, '');
  }
  path = path.replace(/\[(\d+)\]/g, '.$1').replace(/^\./, '');
  if (path !== '') {
    path = '/' + path;
  }
  return path;
};